export default __webpack_public_path__ + "static/media/pic1.c19b1ec6.jpg";